import { useEffect, useState } from "react";

const MAIN_RE = /\/static\/js\/main\.([a-zA-Z0-9]+)\.js/;
const INTERVAL_MS = 5 * 60 * 1000;

function loadedHash() {
  for (const s of document.scripts) {
    const m = MAIN_RE.exec(s.src || "");
    if (m) return m[1];
  }
  return null;
}

async function deployedHash() {
  const res = await fetch(`/index.html?_=${Date.now()}`, { cache: "no-store" });
  if (!res.ok) return null;
  const m = MAIN_RE.exec(await res.text());
  return m ? m[1] : null;
}

// Compares the main bundle hash baked into this tab against the one the server is
// currently serving. In dev (unhashed bundle.js) it stays silent unless ?previewUpdateBanner is set.
export function useVersionCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV === "development" && new URLSearchParams(window.location.search).has("previewUpdateBanner")) {
      setUpdateAvailable(true);
      return undefined;
    }
    const current = loadedHash();
    if (!current) return undefined;

    let cancelled = false;
    const check = async () => {
      try {
        const latest = await deployedHash();
        if (!cancelled && latest && latest !== current) setUpdateAvailable(true);
      } catch { /* offline or transient — try again next tick */ }
    };
    const onVisible = () => { if (document.visibilityState === "visible") check(); };
    const timer = setInterval(check, INTERVAL_MS);
    const first = setTimeout(check, 60 * 1000);
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", check);
    return () => {
      cancelled = true;
      clearInterval(timer); clearTimeout(first);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", check);
    };
  }, []);

  return updateAvailable;
}
